import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setVisible(window.scrollY > 400);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Retour en haut de page"
      className={`fixed right-4 md:right-6 z-40 w-11 h-11 rounded-full bg-white border border-background-200 text-primary-500 flex items-center justify-center shadow-[0_2px_8px_rgba(0,0,0,0.08)] hover:bg-accent-500 hover:text-white hover:border-accent-500 hover:shadow-[0_4px_16px_rgba(242,92,84,0.3)] transition-all duration-300 cursor-pointer bottom-20 md:bottom-6 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <span className="w-5 h-5 flex items-center justify-center">
        <i className="ri-arrow-up-line text-lg"></i>
      </span>
    </button>
  );
}